import { Button } from "@/components/ui/button";
import { GithubIcon, Container } from "lucide-react";
import Invite from "@/components/invite";

export default function GitHub() {
  return (
    <section id="github" className="py-20 bg-muted/50">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">View Our Progress on GitHub</h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Stay up-to-date with PentAGI's development and contribute to our
          open-source project.
        </p>
        <div className="flex justify-center gap-4 mb-8">
          <Button size="lg" variant="outline" asChild>
            <a
              href="https://github.com/vxcontrol/pentagi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GithubIcon className="mr-2 h-5 w-5" /> View on GitHub
            </a>
          </Button>
          <Button size="lg" variant="outline" asChild>
            <a
              href="https://hub.docker.com/r/vxcontrol/pentagi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Container className="mr-2 h-5 w-5" /> View on Docker Hub
            </a>
          </Button>
        </div>

        <Invite />
      </div>
    </section>
  );
}
